import type { TrackingEvent } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useCreate: useTrackingEventCreate } = getCRUDHooks<TrackingEvent>({
  entityName: 'trackingEvent',
  getHelper: () => clientApi.getOCClient().helpers.tracking.events,
});

// eslint-disable-next-line import/prefer-default-export
export { useTrackingEventCreate };
